module.exports = __webpack_public_path__ + "img/tel.a0b93030.png";